const AuthReducer = (state = { isActive: false, jwt: "" }, action) => {
  switch (action.type) {
    case "LOG_IN":
      return {
        ...state,
        isLogged: action.payload,
      };
    case "JWT":
      return {
        ...state,
        jwt: action.payload,
      };
    default:
      return state;
  }
};

export default AuthReducer;
